import React from 'react'
import {
  activity_dates,
  LOCALE,
  topNumber,
} from '../../../constants/activity-constants'
console.log(activity_dates)
const LOCAL = process.env.LOCALE
const urlByLocal = {
  'es-CO': 'https://www.nosotrasonline.com.co/',
  'es-CL': 'https://www.nosotrasonline.cl/',
  'es-PE': 'https://www.nosotrasonline.com.pe/',
  'es-EC': 'https://www.nosotrasonline.com.ec/',
  'es-DO': 'https://www.nosotrasonline.com.do/',
  'es-PR': 'https://www.nosotrasonline.com.pr/',
  'es-BO': 'https://www.nosotrasonline.com.bo/',
  'es-AR': 'https://www.nosotrasonline.com.ar/',
  'es-PY': 'https://www.nosotrasonline.com.py/',
}[LOCAL]

const country = {
  'es-CO': 'Colombia',
  'es-CL': 'Chile',
  'es-PE': 'Perú',
  'es-EC': 'Ecuador',
  'es-DO': 'República Dominicana',
  'es-PR': 'Puerto Rico',
  'es-BO': 'Bolivia',
}[LOCAL]

const linkjsx = urllink => (
  <a href={urllink} className="--link" target="_blank">
    {urllink}
  </a>
)

const link = linkjsx(urlByLocal)
const link_contactanos = linkjsx(urlByLocal + 'contactanos')
let default_terms = [
  <>
    <h5>PRIMERO: ACEPTACIÓN </h5>
    La participación en la Actividad promocional implica el expreso e íntegro
    conocimiento y aceptación de los presentes Términos y Condiciones. El
    participante que no esté de acuerdo con los Términos y Condiciones en los
    que se desarrollará la Actividad tiene el pleno derecho de no participar en
    la misma. Sin embargo, la participación en la Actividad demuestra plenamente
    la aceptación íntegra, total y sin condiciones de los siguientes Términos y
    Condiciones. Essity, se reserva el derecho a modificar parcial o totalmente
    los presentes Términos y Condiciones, sin necesidad de notificación previa a
    las participantes. En todo caso, Essity pondrá a disposición de las
    participantes las modificaciones a la Actividad en los mismos canales y
    cantidades que los Términos y Condiciones iniciales.
  </>,
  <>
    <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
    Grupo Familia como responsable y organizador invita a participar en la
    Actividad Universo Cole, en adelante la “Actividad” de acuerdo con la
    información, condiciones, requisitos y limitaciones, que se detallan en el
    presente documento.
  </>,
  <>
    <h5>TERCERO: VIGENCIA </h5>La Actividad estará vigente a partir del{' '}
    {activity_dates[0]} hasta el {activity_dates[1]}. Durante todo el término de
    la Actividad , las participantes deberán cumplir con los requisitos
    establecidos en el numeral quinto y demás establecidos en el presente
    documento. <br />
    Serán 2 etapas:
    <br />
    ETAPA 1: 1 de marzo al 31 de mayo
    <br />
    ETAPA 2: 1 junio al 31 de agosto
  </>,
  <>
    <h5>CUARTO: TERRITORIO</h5>
    La Actividad se llevará a cabo a través de sitio web
    {link} donde podrán encontrar toda la información y redes sociales donde se
    comunicará la Actividad en las ciudades de aplica para TODO {country}.
  </>,
  <>
    <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
    Los requisitos que deberán cumplir las participantes en la Actividad son los
    siguientes:
    <ul>
      <li>
        1- Las participantes deben estar registradas en
        {link}.
      </li>
      <li>
        2- Participar en la Actividad a través de la página web de {link}.
      </li>
      <li>3- Cumplir con la mecánica de la Actividad. </li>
      <li>4- Las participantes deben residir en {country}.</li>
      <li>
        5- Las participantes declaran conocer y aceptar que la participación en
        la Actividad y la entrega de los premios se encuentra sujeta al cabal
        cumplimiento de todos los Requisitos descritos en el presente documento.
        Por tanto, las participantes se comprometen a cumplir dichos requisitos
        sin condicionamiento alguno y entienden que de no hacerlo no podrán
        concursar, ni recibir los premios.
      </li>
    </ul>
  </>,
  <>
    <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
    <ul>
      <li>
        1- La marca Nosotras y Productos Familia S.A. validará que los datos
        completados en el registro sean correctos, antes de seguir con la
        actividad.
      </li>
      <li>
        2- La actividad se divide en 2 fases. Para cada etapa habrá 10 ganadoras
        y se manejará de la siguiente manera: Fase 1: (10 ganadoras) Puesto 1 -
        Iphone 14 de 128GB Puesto del 2 al 5 - 1 Tablet 10" Alcatel 32 GB Puesto
        del 6 al 10 - Kit de productos Nosotras (1 Aplicador para Tampones + 1
        Nosotras Diarios con Prebióticos x 20 NUEVA + 1 paquete de Nosotras
        Pañitos con Prebióticos x 16 NUEVA + 1 Nosotras Jabón Íntimo con
        Prebióticos x 200 NUEVA + 1 paquete de Nosotras Buenas Noches Máxima
        Protección X 3 + 1 Kit Vulvas) Fase 2: (10 ganadoras) Puesto 1 - Iphone
        14 de 128GB Puesto del 2 al 5 - 1 Tablet 10" Alcatel 32 GB Puesto del 6
        al 10 - Kit de productos Nosotras (1 Panty Intimawear + 1 paquete de
        Nosotras Diarios Largos Con Alas Multiestilo x 72 NUEVA + 1 paquete de
        Nosotras Pañitos con Prebióticos x 16 NUEVA + 1 Nosotras Jabón Íntimo
        Lavanda x 200ml + 1 paquete de Nosotras Buenas Noches Máxima Protección
        X 3 + 1 Kit Vulvas)
      </li>
      <li>
        3- Ganará la usuaria que más puntos acumule y que presente la totalidad
        de los empaques de las claves ingresadas en la actividad.{' '}
      </li>
      <li>
        4- Cada clave ingresada cuenta como UNA clave, sin importar cuantos
        puntos represente.{' '}
      </li>
      <li>
        5- La primera clave que la usuaria ingrese va a tener 5 vidas. (Puede
        ser de cualquier empaque de productos Nosotras).
      </li>
      <li>
        6- Las claves adicionales que la usuaria ingrese van a tener 3 vidas
        (por cada clave adicional, 3 vidas adicionales)
      </li>
      <li>
        7- Si la usuaria ingresa una clave mágica ( que es la que les llega al
        correo o viene en el volante entregado durante las visitas educativas de
        Nosotras®), se le incrementarán las vidas a 10.
      </li>
      <li>
        8- Las participantes tienen que estar en el rango de edad entre los 9 y
        19 años. Se les solicitará a las usuarias un certificado escolar para
        confirmar que evidentemente están estudiando en el colegio.
      </li>
      <li>
        9- La marca Nosotras® y Productos Familia S.A. validará que los datos
        completados en el formulario sean correctos.
      </li>
      <li>10- La usuaria debe guardar los empaques para poder participar.</li>
      <li>11- La usuaria solo puede ganar en una de las fases.</li>
      <li>
        12- Los premios no son canjeables por ningún otro concepto o producto,
        ni es intercambiable por dinero.
      </li>
      <li>
        13- En caso de que la ganadora no pueda recibir su premio, no tendrá
        derecho a reclamo ni a algún tipo de indemnización o compensación, ni
        siquiera parcialmente.
      </li>
      <li>
        14- La marca Nosotras tiene el derecho de anular o descalificar
        cualquier material que considere que no cumple con las reglas del
        concurso. Del mismo modo procederá con el material que no tenga relación
        con la mecánica de la actividad, que considere no apto o que atente
        contra los valores de la marca.
      </li>
      <li>
        15- Los premios de la actividad serán personales e intransferibles, y no
        son acumulables con otras promociones o dinámicas.
      </li>
      <li>
        16- Con el hecho de participar en la actividad, las ganadoras aceptan y
        autorizan que sus nombres e imágenes aparezcan en las publicaciones y
        demás material de divulgación con fines promocionales que los
        organizadores deseen hacer durante la actividad o una vez este finalice,
        sin que ello implique la obligación de remunerarlas o compensarlas.
        Asimismo, renuncian a cualquier reclamo por derechos de imagen. Estos
        datos no serán recogidos para fines distintos a los expresados ni se
        cederán datos a terceros.
      </li>
      <li>
        17- Las claves de las demás usuarias del ranking quedan iguales y se
        siguen acumulando para la segunda y la tercera etapa.
      </li>
      <li>
        18- El nivel de dificultad del juego irá avanzando a medida que avance
        el juego.
      </li>
      <li>
        19- En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las
        claves redimidas en esta actividad, no aplican para esta sección de
        redención.{' '}
      </li>
      <li>
        20- Las usuarias deben tener y enviar a la marca Nosotras® cuando sea
        solicitado, todos los empaques con los que participaron para ser
        ganadoras.
      </li>
      <li>
        21- Al final del concurso, la concursante debe tener una carta que
        certifique que estudia en el colegio registrado y copia de su documento.
      </li>
      <li>
        22- La marca podrá descalificar a las usuarias que detecte que están
        haciendo trampa.
      </li>
      <li>
        23- Al participar en la actividad las usuarias aceptan las condiciones
        establecidas en el reglamento, la página web y correo electrónico.
      </li>
      <li>
        24- La actividad va del {activity_dates[0]} hasta el {activity_dates[1]}
        .
        <br />
        <br />
        Primera Fase: 1 de marzo al 31 de mayo - Ganadoras 10
        <br />
        Segunda Fase: 1 junio al 31 de agosto - Ganadoras 10
      </li>
      <li>
        25- En caso de tener dudas, o si quieres recibir mayor información,
        comunícate con nosotras por nuestras redes sociales o a
        {link_contactanos}
      </li>
    </ul>
  </>,
  <>
    <h5>SÉPTIMO: MÉTODO DE SELECCIÓN DEL GANADOR</h5>
    La Actividad tendrá un ranking o top de jugadoras. Ganarán las {
      topNumber
    }{' '}
    usuarias que más puntaje obtengan entre las fechas pactadas para la
    Actividad . Luego Familia analizará que las usuarias en el Top cumplan con
    todos los criterios de los Términos y Condiciones de la Actividad y las
    contactará para otorgarles su premio.
    <br />
    <br />
    Las ganadoras de cada fase serán anunciadas en las siguientes fechas:
    <br /> Etapa 1: 14 de junio del 2023 <br />
    Etapa 2: 17 de septiembre del 2023
  </>,
  <>
    <h5>OCTAVO: DESCRIPCIÓN Y CONDICIONES DEL PREMIO</h5>
    La Actividad tendrá un ranking o top de jugadoras. Ganarán las {
      topNumber
    }{' '}
    usuarias que más puntaje obtengan entre las fechas pactadas para la
    Actividad . Luego Familia analizará que las usuarias en el Top cumplan con
    todos los criterios de los Términos y Condiciones de la Actividad y las
    contactará para otorgarles su premio.
    <br />
    <br />
    El premio objeto de la Actividad no podrá ser modificado, ni será redimible
    en efectivo.
    <br />
    <br />
    Grupo Familia se reserva el derecho de sustituir el o los premios por uno de
    similar valor y modificar los presentes Términos y Condiciones en cualquier
    momento, informando a las participantes.
  </>,
  <>
    <h5>NOVENO: ENTREGA DEL PREMIO</h5>
    Los ganadores deberán compartir sus datos (nombre completo, correo
    electrónico, cédula de ciudadanía y dirección) por el sitio web {link} Grupo
    Familia enviará el premio durante en un plazo máximo de 15 días hábiles lo
    verán reflejado en su cuenta.
  </>,
  <>
    <h5>DÉCIMO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR </h5>
    No hay gastos asociados a este premio
  </>,
  <>
    <h5> UNDÉCIMO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
    Grupo Familia informa que con el diligenciamiento de tus datos estás
    autorizando el tratamiento de los mismos. Nuestra política de privacidad
    está disponible en {link} . Usaremos tu nombre, número de cédula, teléfono
    celular/fijo, y correo electrónico para comunicarnos en caso de que seas el
    ganador de esta Actividad . Si aceptas darnos tu autorización para procesar
    tus datos, tendrás derecho a conocer, actualizar y rectificar tus datos
    personales; a solicitar prueba de esta autorización; a ser informado sobre
    el tratamiento que Productos Familia S.A. ha dado a tus datos personales; a
    presentar consultas o quejas, o a cancelar tu suscripción en cualquier
    momento, enviando un correo electrónico a [cumplimiento.gf@essity.com]
  </>,
  <>
    Con el hecho de participar en la Actividad , los ganadores aceptan y
    autorizan que su nombre y sus imágenes aparezcan en las publicaciones y
    demás material de divulgación con fines promocionales que los organizadores
    deseen hacer durante el concurso o una vez este finalice, sin que ello
    implique la obligación de remunerarlos o compensarlos.
  </>,
  <>
    Grupo Familia tiene el derecho de anular o descalificar cualquier material
    que considere que no cumple con las reglas del concurso. Asimismo, procederá
    con el material que no tenga relación con la mecánica de la Actividad, que
    considere no apto o atente contra los valores de la marca.
  </>,
  <>
    <b>
      En caso de tener dudas o si quieres recibir más información, comunícate a
      la línea de servicio y atención al cliente de la marca.
    </b>
  </>,
]

if (LOCAL === 'es-AR') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN </h5>
      La participación en Universo Cole promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará Universo Cole tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en Universo Cole demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones.
      <br />
      Essity, se reserva el derecho a modificar parcial o totalmente los
      presentes Términos y Condiciones, sin necesidad de notificación previa a
      las participantes. En todo caso, Essity pondrá a disposición de las
      participantes las modificaciones a Universo Cole en los mismos canales y
      cantidades que los Términos y Condiciones iniciales.
      <br />
      Nosotras® u Algodonera Aconcagua realiza los envíos al interior del país a
      través de los servicios de correo por ende no se hace responsable de la
      integridad de los premios al llegar, ni garantiza su entrega.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD </h5>
      Essity como responsable y organizador invita a participar en Universo
      Cole, en adelante la “Actividad” de acuerdo con la información,
      condiciones, requisitos y limitaciones, que se detallan en el presente
      documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA</h5>
      La Actividad estará vigente a partir del 15 de mayo hasta el 30 de
      noviembre. Durante todo el término de la Actividad , las participantes
      deberán cumplir con los requisitos establecidos en el numeral quinto y
      demás establecidos en el presente documento.
      <br />
      Serán 2 etapas: <br />
      ETAPA 1: 25 de Mayo al 01 de agosto <br />
      ETAPA 2: 02 de agosto al 30 de noviembre <br />
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO ARGENTINA.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR </h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes:
      <ol>
        <li>1. Las participantes deben estar registradas en {link}</li>
        <li>
          2. Participar en la Actividad a través de la página web de {link}
        </li>
        <li>3. Cumplir con la mecánica de la Actividad.</li>
        <li>4. Las participantes deben residir en Argentina.</li>
        <li>
          5. Las participantes declaran conocer y aceptar que la participación
          en la Actividad y la entrega de los premios se encuentra sujeta al
          cabal cumplimiento de todos los Requisitos descritos en el presente
          documento. Por tanto, las participantes se comprometen a cumplir
          dichos requisitos sin condicionamiento alguno y entienden que de no
          hacerlo no podrán concursar, ni recibir los premios.
        </li>
      </ol>
    </>,
    <>
      <h5> SEXTO: MECÁNICA DE LA ACTIVIDAD </h5>
      Para formar parte de esta actividad, las participantes deben estar
      registradas en NosotrasOnline.ar, actualizar sus datos de registro y
      elegir la opción de registro.
      <ol>
        <li>
          1. La marca Nosotras y Essity, S.A. validará que los datos completados
          en el registro sean correctos, antes de seguir con la actividad.
        </li>
        <li>
          2. La actividad se divide en 2 etapas. Para cada etapa habrá 10
          ganadoras y se manejará de la siguiente manera: <br />
          Etapa 1: (10 ganadoras) <br />
          Puesto 1 : 1 Tablet <br />
          Puesto 2: Unos rollers (patines) <br />
          Puesto 3 al 10: Kit de productos Nosotras + Merchandising <br />
          Etapa 2: (10 ganadoras) <br />
          Puesto 1 : 1 Tablet <br />
          Puesto 2: Unos rollers (patines) <br />
          Puesto 3 al 10: 0: Kit de productos Nosotras + Merchandising
        </li>
        <li>
          3. Ganará la usuaria que más puntos acumule y que presente la
          totalidad de los empaques de las claves ingresadas en la actividad.
        </li>
        <li>
          4. Cada clave ingresada cuenta como UNA clave, sin importar cuantos
          puntos represente.
        </li>
        <li>
          5. La primera clave que la usuaria ingrese va a tener 5 vidas. (Puede
          ser de cualquier empaque de productos Nosotras).
        </li>
        <li>
          6. Las claves adicionales que la usuaria ingrese van a tener 3 vidas
          (por cada clave adicional, 3 vidas adicionales)..
        </li>
        <li>
          7. Si la usuaria ingresa una clave mágica (que es la que les llega al
          correo o viene en el volante entregado durante las visitas educativas
          de Nosotras®), se le incrementarán las vidas a 10.
        </li>
        <li>
          8. Las participantes tienen que estar en el rango de edad entre los 9
          y 19 años. Se les solicitará a las usuarias un certificado escolar
          para confirmar que evidentemente están estudiando en el colegio.
        </li>
        <li>
          9. La marca Nosotras® y Essity S.A. validará que los datos completados
          en el formulario sean correctos.
        </li>
        <li>10. La usuaria debe guardar los empaques para poder participar.</li>
        <li>11. La usuaria sólo puede ganar en una de las etapas.</li>
        <li>
          12. Los premios no son canjeables por ningún otro concepto o producto,
          ni es intercambiable por dinero.
        </li>
        <li>
          13. En caso de que la ganadora no pueda recibir su premio, no tendrá
          derecho a reclamo ni a algún tipo de indemnización o compensación, ni
          siquiera parcialmente.
        </li>
        <li>
          14. La marca Nosotras tiene el derecho de anular o descalificar
          cualquier material que considere que no cumple con las reglas del
          concurso. Del mismo modo procederá con el material que no tenga
          relación con la mecánica de la actividad, que considere no apto o que
          atente contra los valores de la marca.
        </li>
        <li>
          15. Los premios de la actividad serán personales e intransferibles, y
          no son acumulables con otras promociones o dinámicas.
        </li>
        <li>
          16. Con el hecho de participar en la actividad, las ganadoras aceptan
          y autorizan que sus nombres e imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante la actividad o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas. Asimismo, renuncian a cualquier reclamo por derechos de
          imagen. Estos datos no serán recogidos para fines distintos a los
          expresados ni se ceden datos a terceros.
        </li>
        <li>
          17. Las claves de las demás usuarias del ranking quedan iguales y se
          siguen acumulando para la segunda y la tercera etapa.
        </li>
        <li>
          18. El nivel de dificultad del juego irá avanzando a medida que avance
          el juego.
        </li>
        <li>
          19. En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las
          claves canjeadas en esta actividad, no aplican para esta sección de
          e-store.
        </li>
        <li>
          20. Las usuarias deben tener y enviar a la marca Nosotras® cuando sea
          solicitado, todos los empaques con los que participaron para ser
          ganadoras.
        </li>
        <li>
          21. Al final del concurso, la concursante debe tener una carta que
          certifique que estudia en el colegio registrado y copia de su
          documento.
        </li>
        <li>
          22. La marca podrá descalificar a las usuarias que detecte que están
          haciendo trampa.
        </li>
        <li>
          23. Al participar en la actividad las usuarias aceptan las condiciones
          establecidas en el reglamento, la página web y correo electrónico.
        </li>
        <li>
          24. La actividad tendrá 2 etapas: <br />
          ETAPA 1: 15 de mayo al 15 de agosto <br />
          ETAPA 2: 16 de agosto al 30 de noviembre <br />
          Esta actividad es válida solo para usuarias que vivan en Argentina.
        </li>
        <li>
          25. En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con nosotras por nuestras redes sociales @nosotrasargentina
          o al correo contactonosotrasargentina@essity.com
        </li>
      </ol>
    </>,
    <>
      <h5>SÉPTIMO: MÉTODO DE SELECCIÓN DEL GANADOR</h5>
      La Actividad tendrá un ranking o top de jugadoras. Ganarán las 20 usuarias
      que más puntaje obtengan entre las fechas pactadas para la Actividad .
      Luego Essity analizará que las usuarias en el Top cumplan con todos los
      criterios de los Términos y Condiciones de la Actividad y las contactará
      para otorgarles su premio.
    </>,
    <>
      <h5> OCTAVO: DESCRIPCIÓN Y CONDICIONES DEL PREMIO</h5>
      <ol>
        <li>
          La Actividad tendrá un ranking o top de jugadoras. Ganarán las 20
          usuarias que más puntaje obtengan entre las fechas pactadas para la
          Actividad . Luego Essity analizará que las usuarias en el Top cumplan
          con todos los criterios de los Términos y Condiciones de la Actividad
          y las contactará para otorgarles su premio.
        </li>
        <li>
          El premio objeto de la Actividad no podrá ser modificado, ni será
          redimible en efectivo.
        </li>
        <li>
          Essity se reserva el derecho de sustituir el o los premios por uno de
          similar valor y modificar los presentes Términos y Condiciones en
          cualquier momento, informando a las participantes.
        </li>
      </ol>
    </>,
    <>
      <h5>NOVENO: ENTREGA DEL PREMIO</h5>
      Los ganadores deberán compartir sus datos (nombre completo, correo
      electrónico, cédula de ciudadanía y dirección) por el sitio web {
        link
      }{' '}
      Essity junto al proveedor logístico enviará el premio durante en un plazo
      máximo de 20 días hábiles lo verán reflejado en su cuenta.
    </>,
    <>
      <h5>DÉCIMO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5>UNDÉCIMO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      <ol>
        <li>
          Essity S.A informa que con el diligenciamiento de tus datos estás
          autorizando el tratamiento de los mismos. Nuestra política de
          privacidad está disponible {link} . Usaremos tu nombre, número de
          cédula, teléfono celular/fijo, y correo electrónico para comunicarnos
          en caso de que seas el ganador de esta Actividad . Si aceptas darnos
          tu autorización para procesar tus datos, tendrás derecho a conocer,
          actualizar y rectificar tus datos personales; a solicitar prueba de
          esta autorización; a ser informado sobre el tratamiento que Productos
          Familia S.A. ha dado a tus datos personales; a presentar consultas o
          quejas, o a cancelar tu suscripción en cualquier momento, enviando un
          correo electrónico a [cumplimiento.gf@essity.com]
        </li>
        <li>
          Con el hecho de participar en la Actividad , los ganadores aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlos o
          compensarlos.
        </li>
        <li>
          Essity tiene el derecho de anular o descalificar cualquier material
          que considere que no cumple con las reglas del concurso. Asimismo,
          procederá con el material que no tenga relación con la mecánica de la
          Actividad, que considere no apto o atente contra los valores de la
          marca.
        </li>
        <li>
          En caso de tener dudas o si quieres recibir más información,
          comunícate a la línea de servicio y atención al cliente de la marca.
        </li>
      </ol>
    </>,
  ]
}

if (LOCALE === 'es-PY') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN</h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. Essity, se reserva el derecho a
      modificar parcial o totalmente los presentes Términos y Condiciones, sin
      necesidad de notificación previa a las participantes. En todo caso, Essity
      pondrá a disposición de las participantes las modificaciones a la
      Actividad en los mismos canales y cantidades que los Términos y
      Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Nosotras Magic Box, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA</h5>
      La Actividad estará vigente a partir del xxx hasta el xxx. Durante todo el
      término de la Actividad , las participantes deberán cumplir con los
      requisitos establecidos en el numeral quinto y demás establecidos en el
      presente documento.
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO PARAGUAY.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: Las participantes deben estar registradas en
      {link} Participar en la Actividad a través de la página web de {link} Las
      usuarias deben canjear 10 puntos por cada wallpaper, 10 puntos por el
      paquete de stickers y 5 puntos por cada tarjeta personalizada que quieran
      descargar. Las usuarias deben cumplir con la mecánica de la Actividad. Las
      participantes deben residir en Paraguay. Las participantes declaran
      conocer y aceptar que la participación en la Actividad . Por tanto, las
      participantes se comprometen a cumplir dichos requisitos sin
      condicionamiento alguno y entienden que de no hacerlo no podrán concursar.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD </h5>
      Todas las participantes de esta Actividad deben estar registradas en
      {link} Las usuarias deben canjear: 10 puntos por cada wallpaper. 10 puntos
      por el paquete de stickers. 5 puntos por cada tarjeta personalizada. Los
      premios no son acumulables con otras promociones o actividades, no son
      intercambiables por dinero ni son canjeables por ningún otro concepto o
      producto identificado con la marca Nosotras ® o de Essity. La marca
      Nosotras tiene el derecho de anular o descalificar cualquier material que
      considere que no cumple con las reglas del concurso. Así mismo, procederá
      con el material que no tenga relación con la mecánica de la Actividad, que
      considere no apto o que atente contra los valores de la marca. Con el
      hecho de participar en la Actividad, , las ganadoras aceptan y autorizan
      que su nombre y sus imágenes aparezcan en las publicaciones y demás
      material de divulgación con fines promocionales que los organizadores
      deseen hacer durante el concurso o una vez este finalice, sin que ello
      implique la obligación de remunerarlas o compensarlas. El hecho de que la
      usuaria participe en la dinámica implica el conocimiento y la aceptación
      de las condiciones establecidas en el reglamento, página web y correo
      electrónico. La Actividad estará al aire desde el xxxxx hasta el xxxxx de
      2022. Concurso válido solo para usuarias que residen en Paraguay. En caso
      de tener dudas, o si quieres recibir mayor información, comunícate con
      nosotras por nuestras redes sociales o a{link_contactanos}
    </>,
    <>
      <h5>SÉPTIMO: DESCRIPCIÓN Y CONDICIONES DE LOS DESCARGABLES</h5>
      Los descargables de la Actividad no podrán ser modificados, ni serán
      canjeables en efectivo. Grupo Familia se reserva el derecho de hacer
      cambios sobre el material descargable.
    </>,
    <>
      <h5>OCTAVO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5>NOVENO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      Grupo Familia informa que con el diligenciamiento de tus datos estás
      autorizando el tratamiento de los mismos. Nuestra política de privacidad
      está disponible en {link} Usaremos tu nombre, número de cédula, teléfono
      celular/fijo, y correo electrónico para comunicarnos en caso de requerirse
      para la presente Actividad. Si aceptas darnos tu autorización para
      procesar tus datos, tendrás derecho a conocer, actualizar y rectificar tus
      datos personales; a solicitar prueba de esta autorización; a ser informado
      sobre el tratamiento que Productos Familia S.A. ha dado a tus datos
      personales; a presentar consultas o quejas, o a cancelar tu suscripción en
      cualquier momento, enviando un correo electrónico a
      [cumplimiento.gf@essity.com]
    </>,
  ]
}

if (LOCALE === 'es-BO') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN </h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. Essity, se reserva el derecho a
      modificar parcial o totalmente los presentes Términos y Condiciones, sin
      necesidad de notificación previa a las participantes. En todo caso, Essity
      pondrá a disposición de las participantes las modificaciones a la
      Actividad en los mismos canales y cantidades que los Términos y
      Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Nosotras Magic Box, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA </h5>La Actividad estará vigente a partir del{' '}
      {activity_dates[0]} hasta el {activity_dates[1]}. Durante todo el término
      de la Actividad , las participantes deberán cumplir con los requisitos
      establecidos en el numeral quinto y demás establecidos en el presente
      documento.{' '}
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO BOLIVIA.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: Las participantes deben estar registradas en
      {link} Participar en la Actividad a través de la página web de {link}. Las
      usuarias deben cumplir con la mecánica de la Actividad. Las participantes
      deben residir en Bolivia. Las participantes declaran conocer y aceptar que
      la participación en la Actividad . Por tanto, las participantes se
      comprometen a cumplir dichos requisitos sin condicionamiento alguno y
      entienden que de no hacerlo no podrán concursar.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
      Todas las participantes de esta Actividad deben estar registradas en
      {link} Las usuarias deben redimir: 2 puntos por cada wallpaper. 2 puntos
      por cada sticker. 5 puntos por cada tarjeta personalizada. Los premios no
      son acumulables con otras promociones o actividades, no son
      intercambiables por dinero ni son canjeables por ningún otro concepto o
      producto identificado con la marca Nosotras ® o de Essity. La marca
      Nosotras tiene el derecho de anular o descalificar cualquier material que
      considere que no cumple con las reglas del concurso. Así mismo, procederá
      con el material que no tenga relación con la mecánica de la Actividad, que
      considere no apto o que atente contra los valores de la marca. Con el
      hecho de participar en la Actividad, , las ganadoras aceptan y autorizan
      que su nombre y sus imágenes aparezcan en las publicaciones y demás
      material de divulgación con fines promocionales que los organizadores
      deseen hacer durante el concurso o una vez este finalice, sin que ello
      implique la obligación de renumerarlas o compensarlas. El hecho de que la
      usuaria participe en la dinámica implica el conocimiento y la aceptación
      de las condiciones establecidas en reglamento, página web y correo
      electrónico. La Actividad estará al aire desde el {activity_dates[0]}{' '}
      hasta el {activity_dates[1]}. Concurso válido solo para usuarias que
      residen en Bolivia. En caso de tener dudas, o si quieres recibir mayor
      información, comunícate con nosotras por nuestras redes sociales o a{' '}
      {link_contactanos}
    </>,
    <>
      <h5>SÉPTIMO: DESCRIPCIÓN Y CONDICIONES DE LOS DESCARGABLES</h5>
      Los descargables de la Actividad no podrán ser modificados, ni serán
      canjeables en efectivo. Grupo Familia se reserva el derecho de hacer
      cambios sobre el material descargable.
    </>,
    <>
      <h5>OCTAVO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5> NOVENO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      Grupo Familia informa que con el diligenciamiento de tus datos estás
      autorizando el tratamiento de los mismos. Nuestra política de privacidad
      está disponible en {link}. Usaremos tu nombre, número de cédula, teléfono
      celular/fijo, y correo electrónico para comunicarnos en caso de que seas
      el ganador de esta Actividad . Si aceptas darnos tu autorización para
      procesar tus datos, tendrás derecho a conocer, actualizar y rectificar tus
      datos personales; a solicitar prueba de esta autorización; a ser informado
      sobre el tratamiento que Productos Familia S.A. ha dado a tus datos
      personales; a presentar consultas o quejas, o a cancelar tu suscripción en
      cualquier momento, enviando un correo electrónico a
      [cumplimiento.gf@essity.com]{' '}
    </>,
  ]
}

if (LOCALE === 'es-EC') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN </h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. <br />
      Essity, se reserva el derecho a modificar parcial o totalmente los
      presentes Términos y Condiciones, sin necesidad de notificación previa a
      las participantes. En todo caso, Essity pondrá a disposición de las
      participantes las modificaciones a la Actividad en los mismos canales y
      cantidades que los Términos y Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Grupo Familia como responsable y organizador invita a participar en la
      Actividad Universo Cole, en adelante la “Actividad” de acuerdo con la
      información, condiciones, requisitos y limitaciones, que se detallan en el
      presente documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA </h5>
      La Actividad estará vigente a partir del 1 de mayo hasta el 15 de
      noviembre, Durante todo el término de la Actividad, las participantes
      deberán cumplir con los requisitos establecidos en el numeral quinto y
      demás establecidos en el presente documento.
      <br />
      Serán 2 etapas:
      <br />
      ETAPA 1: 15 de mayo al 31 de julio de 2023
      <br />
      ETAPA 2: 1 de Agosto al 15 de octubre de 2023
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO ECUADOR.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR </h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: <br />
      1- Las participantes deben estar registradas en{link}
      <br />
      2- Participar en la Actividad a través de la página web de{link}
      <br />
      3- Cumplir con la mecánica de la Actividad.
      <br />
      4- Las participantes deben residir en Ecuador.
      <br />
      5- Las participantes declaran conocer y aceptar que la participación en la
      Actividad y la entrega de los premios se encuentra sujeta al cabal
      cumplimiento de todos los Requisitos descritos en el presente documento.
      Por tanto, las participantes se comprometen a cumplir dichos requisitos
      sin condicionamiento alguno y entienden que de no hacerlo no podrán
      concursar, ni recibir los premios.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
      Para formar parte de esta actividad, las participantes deben estar
      <strong> registradas en NosotrasOnline.com.ec, </strong>
      actualizar sus datos de registro y elegir la opción de registro. <br />
      1- La marca Nosotras y Productos Familia S.A. validará que los datos
      completados en el registro sean correctos, antes de seguir con la
      actividad. <br />
      2- La actividad se divide en 2 etapas. Para cada etapa habrá 5 ganadoras y
      se manejará de la siguiente manera: <br />
      Etapa 1: (5 ganadoras) <br />
      Puesto 1: 1 Iphone 13 negro de 128GB <br />
      Puesto 2: 1 IPad 9na generacion 64gb <br />
      Puesto del 3 a 5: Merchandising (Set de estuches) + Kit de productos
      Nosotras (1 Panty Intimawear negro bikini+ 1 paquete de Nosotras Diarios
      Largos Con Alas Multiestilo + 1 paquete de Nosotras Pañitos con
      Prebióticos x 16 NUEVA + 1 Nosotras Jabón Íntimo con Prebióticos x 200
      NUEVA + 1 paquete de Nosotras Buenas Noches Máxima Protección X 3) <br />
      Etapa 2: (5 ganadoras) <br />
      Puesto 1: 1 Iphone 13 de 128GB <br />
      Puesto 2: IPad 9na generación 64gb <br />
      Puesto del 3 a 5: Merchandising (Set de estuches) + Kit de productos
      Nosotras (1 Panty Intimawear negro bikini+ 1 paquete de Nosotras Diarios
      Largos Con Alas Multiestilo + 1 paquete de Nosotras Pañitos con
      Prebióticos x 16 NUEVA + 1 Nosotras Jabón Íntimo con Prebióticos x 200
      NUEVA + 1 paquete de Nosotras Buenas Noches Máxima Protección X 3) 3-
      Ganará la usuaria que más puntos acumule y que presente la totalidad de
      los empaques de las claves ingresadas en la actividad. <br />
      4- Cada clave ingresada cuenta como UNA clave, sin importar cuantos puntos
      represente. <br />
      5- La primera clave que la usuaria ingrese va a tener 5 vidas. (Puede ser
      de cualquier empaque de productos Nosotras). <br />
      6- Las claves adicionales que la usuaria ingrese van a tener 3 vidas (por
      cada clave adicional, 3 vidas adicionales). <br />
      7- Si la usuaria ingresa una clave mágica ( que es la que les llega al
      correo o viene en el volante entregado durante las visitas educativas de
      Nosotras®), se le incrementarán las vidas a 10. <br />
      8- Las participantes tienen que estar en el rango de edad entre los 9 y 19
      años. Se les solicitará a las usuarias un certificado escolar para
      confirmar que evidentemente están estudiando en el colegio. <br />
      9- La marca Nosotras® y Productos Familia S.A. validará que los datos
      completados en el formulario sean correctos. <br />
      10- La usuaria debe guardar los empaques para poder participar. <br />
      11- La usuaria solo puede ganar en una de las etapas. <br />
      12- Los premios no son canjeables por ningún otro concepto o producto, ni
      es intercambiable por dinero. <br />
      13- En caso de que la ganadora no pueda recibir su premio, no tendrá
      derecho a reclamo ni a algún tipo de indemnización o compensación, ni
      siquiera parcialmente. <br />
      14- La marca Nosotras tiene el derecho de anular o descalificar cualquier
      material que considere que no cumple con las reglas del concurso. Del
      mismo modo procederá con el material que no tenga relación con la mecánica
      de la actividad, que considere no apto o que atente contra los valores de
      l a marca. <br />
      15- Los premios de la actividad serán personales e intransferibles, y no
      son acumulables con otras promociones o dinámicas. <br />
      16- Con el hecho de participar en la actividad, las ganadoras aceptan y
      autorizan que sus nombres e imágenes aparezcan en las publicaciones y
      demás material de divulgación con fines promocionales que los
      organizadores deseen hacer durante la actividad o una vez este finalice,
      sin que ello implique la obligación de remunerarlas o compensarlas.
      Asimismo, renuncian a cualquier reclamo por derechos de imagen. Estos
      datos no serán recogidos para fines distintos a los expresados ni se
      cederán datos a terceros. <br />
      17- Las claves de las demás usuarias del ranking quedan iguales y se
      siguen acumulando para la segunda y la tercera etapa. <br />
      18- El nivel de dificultad del juego irá avanzando a medida que avance el
      juego. <br />
      19- En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las claves
      redimidas en esta actividad, no aplican para esta sección de redención.{' '}
      <br />
      20- Las usuarias deben tener y enviar a la marca Nosotras® cuando sea
      solicitado, todos los empaques con los que participaron para ser
      ganadoras. <br />
      21- Al final del concurso, la concursante debe tener una carta que
      certifique que estudia en el colegio registrado y copia de su documento.{' '}
      <br />
      22- La marca podrá descalificar a las usuarias que detecte que están
      haciendo trampa. <br />
      23- Al participar en la actividad las usuarias aceptan las condiciones
      establecidas en el reglamento, la página web y correo electrónico. <br />
      24- ctividad tendrá 2 etapas: <br />
      Etapa 1: 1 de Mayo al 31 de Julio <br />
      Etapa 2: 16 agosto al 15 de noviembre <br />
      Esta actividad es válida solo para usuarias que vivan en Ecuador. <br />
      25- En caso de tener dudas, o si quieres recibir mayor información,
      comunícate con nosotras por nuestras redes sociales o a {link_contactanos}
    </>,
    <>
      <h5>SÉPTIMO: MÉTODO DE SELECCIÓN DEL GANADOR</h5>
      La Actividad tendrá un ranking o top de jugadoras. Ganarán las xx usuarias
      que más puntaje obtengan entre las fechas pactadas para la Actividad .
      Luego Familia analizará que las usuarias en el Top cumplan con todos los
      criterios de los Términos y Condiciones de la Actividad y las contactará
      para otorgarles su premio.
    </>,
    <>
      <h5>OCTAVO: DESCRIPCIÓN Y CONDICIONES DEL PREMIO</h5>
      La Actividad tendrá un ranking o top de jugadoras. Ganarán las xx usuarias
      que más puntaje obtengan entre las fechas pactadas para la Actividad .
      Luego Familia analizará que las usuarias en el Top cumplan con todos los
      criterios de los Términos y Condiciones de la Actividad y las contactará
      para otorgarles su premio. <br /> <br />
      El premio objeto de la Actividad no podrá ser modificado, ni será
      redimible en efectivo. <br /> <br />
      Grupo Familia se reserva el derecho de sustituir el o los premios por uno
      de similar valor y modificar los presentes Términos y Condiciones en
      cualquier momento, informando a las participantes.
    </>,
    <>
      <h5> NOVENO: ENTREGA DEL PREMIO</h5>
      Los ganadores deberán compartir sus datos (nombre completo, correo
      electrónico, cédula de ciudadanía y dirección) por el sitio web {
        link
      }{' '}
      Grupo Familia enviará el premio durante en un plazo máximo de 15 días
      hábiles lo verán reflejado en su cuenta.
    </>,
    <>
      <h5> DÉCIMO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio.
    </>,
    <>
      <h5> UNDÉCIMO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      Grupo Familia informa que con el diligenciamiento de tus datos estás
      autorizando el tratamiento de los mismos. Nuestra política de privacidad
      está disponible en
      {link} . Usaremos tu nombre, número de cédula, teléfono celular/fijo, y
      correo electrónico para comunicarnos en caso de que seas el ganador de
      esta Actividad . Si aceptas darnos tu autorización para procesar tus
      datos, tendrás derecho a conocer, actualizar y rectificar tus datos
      personales; a solicitar prueba de esta autorización; a ser informado sobre
      el tratamiento que Productos Familia S.A. ha dado a tus datos personales;
      a presentar consultas o quejas, o a cancelar tu suscripción en cualquier
      momento, enviando un correo electrónico a [cumplimiento.gf@essity.com]{' '}
      <br />
      <br />
      Con el hecho de participar en la Actividad , los ganadores aceptan y
      autorizan que su nombre y sus imágenes aparezcan en las publicaciones y
      demás material de divulgación con fines promocionales que los
      organizadores deseen hacer durante el concurso o una vez este finalice,
      sin que ello implique la obligación de remunerarlos o compensarlos. <br />{' '}
      <br />
      Grupo Familia tiene el derecho de anular o descalificar cualquier material
      que considere que no cumple con las reglas del concurso. Asimismo,
      procederá con el material que no tenga relación con la mecánica de la
      Actividad, que considere no apto o atente contra los valores de la marca.{' '}
      <br /> <br />
      En caso de tener dudas o si quieres recibir más información, comunícate a
      la línea de servicio y atención al cliente de la marca.
    </>,
  ]
}

if (LOCALE === 'es-CL') {
  default_terms = [
    <>
      <h5>PRIMERO: ACEPTACIÓN</h5>
      La participación en la Actividad promocional implica el expreso e íntegro
      conocimiento y aceptación de los presentes Términos y Condiciones. El
      participante que no esté de acuerdo con los Términos y Condiciones en los
      que se desarrollará la Actividad tiene el pleno derecho de no participar
      en la misma. Sin embargo, la participación en la Actividad demuestra
      plenamente la aceptación íntegra, total y sin condiciones de los
      siguientes Términos y Condiciones. <br />
      Essity, se reserva el derecho a modificar parcial o totalmente los
      presentes Términos y Condiciones, sin necesidad de notificación previa a
      las participantes. En todo caso, Essity pondrá a disposición de las
      participantes las modificaciones a la Actividad en los mismos canales y
      cantidades que los Términos y Condiciones iniciales.
    </>,
    <>
      <h5>SEGUNDO: RESPONSABLE DE LA ACTIVIDAD</h5>
      Essity como responsable y organizador invita a participar en la Actividad
      Universo Cole, en adelante la “Actividad” de acuerdo con la información,
      condiciones, requisitos y limitaciones, que se detallan en el presente
      documento.
    </>,
    <>
      <h5>TERCERO: VIGENCIA</h5>
      La Actividad estará vigente a partir del 15 de junio hasta el 30 de
      noviembre. Durante todo el término de la Actividad , las participantes
      deberán cumplir con los requisitos establecidos en el numeral quinto y
      demás establecidos en el presente documento.
      <br />
      Serán 2 etapas:
      <br />
      ETAPA 1: 15 de junio al 31 de agosto
      <br />
      ETAPA 2: 1 de septiembre al 30 de noviembre
    </>,
    <>
      <h5>CUARTO: TERRITORIO</h5>
      La Actividad se llevará a cabo a través de sitio web
      {link} donde podrán encontrar toda la información y redes sociales donde
      se comunicará la Actividad en las ciudades de aplica para TODO CHILE.
    </>,
    <>
      <h5>QUINTO: REQUISITOS PARA PARTICIPAR</h5>
      Los requisitos que deberán cumplir las participantes en la Actividad son
      los siguientes: <br />
      1- Las participantes deben estar registradas en {link}
      <br />
      2- Participar en la Actividad a través de la página web de {link}
      <br />
      3- Cumplir con la mecánica de la Actividad.
      <br />
      4- Las participantes deben residir en Chile.
      <br />
      5- Las participantes declaran conocer y aceptar que la participación en la
      Actividad y la entrega de los premios se encuentra sujeta al cabal
      cumplimiento de todos los Requisitos descritos en el presente documento.
      Por tanto, las participantes se comprometen a cumplir dichos requisitos
      sin condicionamiento alguno y entienden que de no hacerlo no podrán
      concursar, ni recibir los premios.
    </>,
    <>
      <h5>SEXTO: MECÁNICA DE LA ACTIVIDAD</h5>
      Para formar parte de esta actividad, las participantes deben estar
      <strong> registradas en {link}, </strong>
      actualizar sus datos de registro y elegir la opción de registro.
      <br />
      <lo>
        <li>
          1. La marca Nosotras y Essity, S.A. validará que los datos completados
          en el registro sean correctos, antes de seguir con la actividad.
        </li>
        <li>
          2. La actividad se divide en 2 etapas. Para cada etapa habrá 5
          ganadoras y se manejará de la siguiente manera: Etapa 1: (5 ganadoras)
          <br />
          Puesto 1: 1 Notebook Ideapad 3 Intel Core I3 8GB
          <br />
          Puesto 2: Samsung Galaxy Tab A8 10.5” 64GB WIFI
          <br />
          Puesto del 3 a 5: Kit de productos Nosotras Pro-Defense V + Cur-V +
          Lonchera
          <br />
          Etapa 2: (5 ganadoras)
          <br />
          Puesto 1: 1 Notebook Ideapad 3 Intel Core I3 8GB
          <br />
          Puesto 2: Samsung Galaxy Tab A8 10.5” 64GB WIFI
          <br />
          Puesto del 3 a 5: Kit de productos Nosotras Pro-Defense V + Cur-V +
          Lonchera
          <br />
        </li>
        <li>
          3. Ganará la usuaria que más puntos acumule y que presente la
          totalidad de los empaques de las claves ingresadas en la actividad.
        </li>
        <li>
          4. Cada clave ingresada cuenta como UNA clave, sin importar cuantos
          puntos represente.
        </li>
        <li>
          5. La primera clave que la usuaria ingrese va a tener 5 vidas. (Puede
          ser de cualquier empaque de productos Nosotras).
        </li>
        <li>
          6. Las claves adicionales que la usuaria ingrese van a tener 3 vidas
          (por cada clave adicional, 3 vidas adicionales).
        </li>
        <li>
          7. Si la usuaria ingresa una clave mágica (que es la que les llega al
          correo o viene en el volante entregado durante las visitas educativas
          de Nosotras®), se le incrementarán las vidas a 10.
        </li>
        <li>
          8. Las participantes tienen que estar en el rango de edad entre los 9
          y 19 años. Se les solicitará a las usuarias un certificado escolar
          para confirmar que evidentemente están estudiando en el colegio.
        </li>
        <li>
          9. La marca Nosotras® y Essity S.A. validará que los datos completados
          en el formulario sean correctos.
        </li>
        <li>10. La usuaria debe guardar los empaques para poder participar.</li>
        <li>11. La usuaria sólo puede ganar en una de las etapas.</li>
        <li>
          12. Los premios no son canjeables por ningún otro concepto o producto,
          ni es intercambiable por dinero.
        </li>
        <li>
          13. En caso de que la ganadora no pueda recibir su premio, no tendrá
          derecho a reclamo ni a algún tipo de indemnización o compensación, ni
          siquiera parcialmente.
        </li>
        <li>
          14. La marca Nosotras tiene el derecho de anular o descalificar
          cualquier material que considere que no cumple con las reglas del
          concurso. Del mismo modo procederá con el material que no tenga
          relación con la mecánica de la actividad, que considere no apto o que
          atente contra los valores de la marca.
        </li>
        <li>
          15. Los premios de la actividad serán personales e intransferibles, y
          no son acumulables con otras promociones o dinámicas.
        </li>
        <li>
          16. Con el hecho de participar en la actividad, las ganadoras aceptan
          y autorizan que sus nombres e imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante la actividad o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas. Asimismo, renuncian a cualquier reclamo por derechos de
          imagen. Estos datos no serán recogidos para fines distintos a los
          expresados ni se ceden datos a terceros.
        </li>
        <li>
          17. Las claves de las demás usuarias del ranking quedan iguales y se
          siguen acumulando para la segunda y la tercera etapa.
        </li>
        <li>
          18. El nivel de dificultad del juego irá avanzando a medida que avance
          el juego.
        </li>
        <li>
          19. En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las
          claves canjeadas en esta actividad, no aplican para esta sección de
          e-store.
        </li>
        <li>
          20. Las usuarias deben tener y enviar a la marca Nosotras® cuando sea
          solicitado, todos los empaques con los que participaron para ser
          ganadoras.
        </li>
        <li>
          21. Al final del concurso, la concursante debe tener una carta que
          certifique que estudia en el colegio registrado y copia de su
          documento.
        </li>
        <li>
          22. La marca podrá descalificar a las usuarias que detecte que están
          haciendo trampa.
        </li>
        <li>
          23. Al participar en la actividad las usuarias aceptan las condiciones
          establecidas en el reglamento, la página web y correo electrónico.
        </li>
        <li>
          24. La actividad tendrá 2 etapas: <br />
          ETAPA 1: 15 de junio al 31 de agosto <br />
          ETAPA 2: 1 de septiembre al 30 de noviembre <br />
          Esta actividad es válida solo para usuarias que vivan en Chile.
        </li>
        <li>
          25- En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con nosotras por nuestras redes sociales @nosotraschile o
          al correo
          {link_contactanos}
        </li>
      </lo>
    </>,
    <>
      <h5>SÉPTIMO: MÉTODO DE SELECCIÓN DEL GANADOR</h5>
      La Actividad tendrá un ranking o top de jugadoras. Ganarán las 10 usuarias
      que más puntaje obtengan entre las fechas pactadas para la Actividad .
      Luego Essity analizará que las usuarias en el Top cumplan con todos los
      criterios de los Términos y Condiciones de la Actividad y las contactará
      para otorgarles su premio.
    </>,
    <>
      <h5>OCTAVO: DESCRIPCIÓN Y CONDICIONES DEL PREMIO</h5>
      La Actividad tendrá un ranking o top de jugadoras. Ganarán las 10 usuarias
      que más puntaje obtengan entre las fechas pactadas para la Actividad .
      Luego Essity analizará que las usuarias en el Top cumplan con todos los
      criterios de los Términos y Condiciones de la Actividad y las contactará
      para otorgarles su premio.
      <br />
      El premio objeto de la Actividad no podrá ser modificado, ni será
      redimible en efectivo.
      <br />
      Essity se reserva el derecho de sustituir el o los premios por uno de
      similar valor y modificar los presentes Términos y Condiciones en
      cualquier momento, informando a las participantes.
    </>,
    <>
      <h5> NOVENO: ENTREGA DEL PREMIO</h5>
      Los ganadores deberán compartir sus datos (nombre completo, correo
      electrónico, cédula de ciudadanía y dirección) por el sitio web {link}
      Essity junto al proveedor logístico enviará el premio durante en un plazo
      máximo de 20 días hábiles lo verán reflejado en su cuenta.
    </>,
    <>
      <h5> DÉCIMO: GASTOS QUE DEBE ASUMIR EL CONSUMIDOR</h5>
      No hay gastos asociados a este premio
    </>,
    <>
      <h5> UNDÉCIMO: AUTORIZACIÓN TRATAMIENTO DE DATOS</h5>
      <ol>
        <li>
          Essity S.A informa que con el diligenciamiento de tus datos estás
          autorizando el tratamiento de los mismos. Nuestra política de
          privacidad está disponible en {link} . Usaremos tu nombre, número de
          cédula, teléfono celular/fijo, y correo electrónico para comunicarnos
          en caso de que seas el ganador de esta Actividad . Si aceptas darnos
          tu autorización para procesar tus datos, tendrás derecho a conocer,
          actualizar y rectificar tus datos personales; a solicitar prueba de
          esta autorización; a ser informado sobre el tratamiento que Productos
          Familia S.A. ha dado a tus datos personales; a presentar consultas o
          quejas, o a cancelar tu suscripción en cualquier momento, enviando un
          correo electrónico a [cumplimiento.gf@essity.com]
        </li>
        <li>
          Con el hecho de participar en la Actividad, los ganadores aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlos o
          compensarlos.
        </li>
        <li>
          Essity tiene el derecho de anular o descalificar cualquier material
          que considere que no cumple con las reglas del concurso. Asimismo,
          procederá con el material que no tenga relación con la mecánica de la
          Actividad, que considere no apto o atente contra los valores de la
          marca.
        </li>
        <li>
          En caso de tener dudas o si quieres recibir más información,
          comunícate a la línea de servicio y atención al cliente de la marca.
        </li>
      </ol>
    </>,
  ]
}
const TERMS = default_terms

export default TERMS
